/*
 * In node.js for the default .stack defined by Error or Error.captureStackTrace
 * Object.getOwnPropertyDescriptor(error, 'stack') returns an already materialized stack
 * { value: string } - thus no hope for lazy evaluation of stack value.
 * In Firefox, the stack is not an own property.
 * In Chrome a PropertyDescriptor with a getter is returned, but it always evaluates to undefined.
 */
export class CustomError extends Error {
    constructor(message, opts = {}) {
        super(message);
        Object.setPrototypeOf(this, CustomError.prototype);
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, CustomError);
        }
        this.metadata = opts.metadata;
    }
}
//# sourceMappingURL=custom_error.js.map